import { render, staticRenderFns } from "./PromoTermsConditions.vue?vue&type=template&id=54a81b77&scoped=true&"
import script from "./PromoTermsConditions.vue?vue&type=script&lang=ts&"
export * from "./PromoTermsConditions.vue?vue&type=script&lang=ts&"
import style0 from "./PromoTermsConditions.vue?vue&type=style&index=0&id=54a81b77&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a81b77",
  null
  
)

export default component.exports